import { proxy } from 'valtio';

const holzarbeitTimebarState = proxy({
  areaActive: false,
  splinePoint: 1,
});

export default holzarbeitTimebarState;
